import { PRICE_ID_TO_GRAMS } from '@iheartjane/menu';
import { Button, Flex, Typography } from '@iheartjane/reefer';
import { formatCurrency } from '@iheartjane/utils';

import type { WeightSelectorWeight } from '@jane/shared-ecomm/types';

import { useProductCardContext } from '../productCardProvider';

import styles from './weightButton.module.css';

interface WeightButtonProps {
  weight: WeightSelectorWeight;
}

export const WeightButton = ({ weight }: WeightButtonProps) => {
  const {
    setSelectedWeight,
    selectedWeight,
    menuProduct: product,
  } = useProductCardContext();

  const originalPrice = product ? product[`price_${weight.value}`] : null;

  const isPriceDifferent =
    originalPrice && String(weight.price) !== originalPrice;

  return (
    <div className={styles['formWeightsButtonContainer']}>
      <Button
        label={
          <Flex gap={4}>
            <Typography variant="body-bold">
              {formatCurrency(weight.price, true)}
            </Typography>
            {isPriceDifferent && (
              <Typography variant="body-bold" strikeThrough color="grays-mid">
                {formatCurrency(originalPrice, true)}
              </Typography>
            )}
          </Flex>
        }
        subLabel={
          weight.value === 'each' ? '' : `${PRICE_ID_TO_GRAMS[weight.value]}g`
        }
        size="jumbo"
        variant={
          selectedWeight === weight.value ? 'tertiary-selected' : 'tertiary'
        }
        full
        onClick={() => {
          setSelectedWeight(weight.value);
        }}
      />
    </div>
  );
};
